import axios from 'axios'
import { isLocal } from 'modules/app-config/environment'
import { getUrl } from 'enrollment-platform/api/eps.client'

const LOCAL_EPS_URL = 'http://localhost:3010'

// Note the reversed path segment order vs annual-benefit-planning-v2.api.ts
// (api/v2/annual-benefit-planning): ContributionModelController
// (abp-4-contribution-modeling module) is mounted at api/annual-benefit-planning/v2
// verbatim, not under the older api/v2/annual-benefit-planning family.
function getContributionModelApiBaseUrl(): string {
  if (isLocal()) {
    return `${LOCAL_EPS_URL}/api/annual-benefit-planning/v2`
  }

  return `${getUrl()}/api/annual-benefit-planning/v2`
}

export const contributionModelApi = axios.create({
  baseURL: getContributionModelApiBaseUrl(),
  headers: { 'Content-Type': 'application/json' },
  timeout: 5 * 60 * 1000,
})

contributionModelApi.interceptors.request.use(
  (config) => {
    const { idToken } = JSON.parse(localStorage.getItem('admin-token') || '{}')
    if (typeof idToken === 'string' && idToken.length > 0) {
      config.headers.Authorization = idToken
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default contributionModelApi
